import React from "react";
import { TextMarquee as TextMarqueeComponent } from "~components";

const TextMarquee = ({
  data: {
    marqueeSettings: { text, backgroundColor, textColor }
  }
}) => (
  <TextMarqueeComponent
    phrases={text}
    initialBackgroundColor={backgroundColor.hex}
    textColor={textColor.hex}
  />
);

export default TextMarquee;
